export default "__VITE_ASSET__BmGYJkfl__"